import {ChangeDetectorRef, Component, ComponentFactoryResolver,} from '@angular/core';
import {ConfirmationService, MessageService} from 'primeng/api';
import {TranslateService} from '@ngx-translate/core';
import {FieldRecord} from "../../../model/api/field-record";
import {FieldRequest} from "../../../model/api/field-request";
import {FormFieldConfig} from "../../../model/api/form-field-config";
import {CommonFieldService} from "../../../services/common/common-field.service";
import {CrudBaseComponent} from "../../../crystal-elements/crud/crud-base.component";
import TYPE = FormFieldConfig.TYPE;
import {SrcMappingTradeType} from "../../../model/mapping/src-mapping-trade-type";
import {MappingSrcMappingTradeTypeService} from "../../../services/mapping/mapping-src-mapping-trade-type.service";

@Component({
  selector: 'app-mapp-trade-type',
  templateUrl: './src-mapping-trade-type.component.html',
  providers: [
    MessageService,
    ConfirmationService,
    TranslateService,
  ],
})
export class SrcMappingTradeTypeComponent extends CrudBaseComponent<SrcMappingTradeType> {

  //fields
  sources: FieldRecord<any>[];
  exchanges: FieldRecord<any>[];

  constructor(cdref: ChangeDetectorRef,
              crudService: MappingSrcMappingTradeTypeService,
              commonFieldService: CommonFieldService,
              componentFactoryResolver: ComponentFactoryResolver,
              messageService: MessageService,
              confirmationService: ConfirmationService,
              translateService: TranslateService) {
    super(cdref, messageService, confirmationService, translateService, commonFieldService);
    this.crudService = crudService;
    this.newRecord = new SrcMappingTradeType();
    this.newRecord.id = -1;
    this.prepareForClone = this.prepareRecordForClone;
  }

  prepareRecordForClone() {
    if (this.formRecord) {
      this.formRecord.id = -1;
      this.formRecord.sourceTradeType = undefined;
    }
  }

  protected initConfigs() {
    super.initConfigs();

    this.tableConfig = [
      {
        field: 'sourceCode',
        width: 130
      },
      {
        field: 'crystalExchangeCode',
        width: 130,
        icon: (record: any) => {
          const exchField = this.exchanges ? this.exchanges.find(field => field.value
            && field.value.code === record.crystalExchangeCode) : undefined;
          if (exchField && exchField.value) {
            return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
          } else {
            return 'fas fa-globe-europe';
          }
        }
      },
      {
        field: 'crystalTradeType',
        width: 130
      },
      {
        field: 'sourceTradeType',
        width: 130
      }];

    this.formConfig = [
      {
        group: '',
        fields: [
          {
            field: 'sourceCode',
            required: true,
            filter: true,
            column: 3,
            type: TYPE.DROPDOWN,
            options: () => this.sources,
          },
          {
            field: 'crystalExchangeCode',
            required: true,
            filter: true,
            column: 3,
            type: TYPE.DROPDOWN,
            options: () => this.exchanges,
            icon: (ig: any) => {
              const exchField = this.exchanges ? this.exchanges.find(field => field.value && field.value.code === ig) : undefined;
              if (exchField && exchField.value) {
                return exchField.value.country ? 'flag-icon flag-icon-' + exchField.value.country.toLowerCase() : '';
              } else {
                return 'fas fa-globe-europe';
              }
            }
          },
          {
            field: 'crystalTradeType',
            required: true,
            column: 3,
            type: TYPE.TEXT
          },
          {
            field: 'sourceTradeType',
            required: true,
            column: 3,
            type: TYPE.TEXT
          }]
      }];
  }

  protected initData() {
    super.initData();

    this.settingsFormLoadingProgressValue = 0;

    this.commonFieldService.getSources(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.sources = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 2;
    });

    this.commonFieldService.getExchangeCodes(FieldRequest.DEFAULT()).subscribe(fieldResult => {
      this.exchanges = fieldResult.records ? [...this.getFields(fieldResult)] : [];
      this.settingsFormLoadingProgressValue += 100 / 2;
    });

  }

  onFormShow() {
  }
}
